
      module.exports = {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"viewBox":"0 0 18 18","fill":"none","xmlns":"http://www.w3.org/2000/svg"}, attrs),
              ...rest,
            },
            children.concat([_c('circle',{attrs:{"cx":"9","cy":"9","r":"3","stroke":"#2a2b2e","stroke-width":"1.5"}}),_c('path',{attrs:{"d":"M7.347 2.009c.748-1.25 2.558-1.25 3.306 0a1.93 1.93 0 0 0 2.122.878c1.412-.353 2.691.926 2.338 2.338-.207.824.15 1.685.878 2.122 1.25.748 1.25 2.558 0 3.306a1.93 1.93 0 0 0-.878 2.122c.353 1.412-.926 2.691-2.338 2.338a1.93 1.93 0 0 0-2.122.878c-.748 1.25-2.558 1.25-3.306 0a1.93 1.93 0 0 0-2.122-.878c-1.412.353-2.691-.926-2.338-2.338a1.93 1.93 0 0 0-.878-2.122c-1.25-.748-1.25-2.558 0-3.306a1.93 1.93 0 0 0 .878-2.122c-.353-1.412.926-2.691 2.338-2.338a1.93 1.93 0 0 0 2.122-.878Z","stroke":"#2a2b2e","stroke-width":"1.5"}})])
          )
        }
      }
    